var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("titles.addresses")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c(
                            "w-row",
                            { attrs: { "no-margin": "", "no-wrap": "" } },
                            [
                              _c("w-tabs", {
                                staticClass: "btt-next",
                                attrs: { tabs: _vm.addressTabs },
                                model: {
                                  value: _vm.activeAddressTab,
                                  callback: function ($$v) {
                                    _vm.activeAddressTab = $$v
                                  },
                                  expression: "activeAddressTab",
                                },
                              }),
                              _c("w-spacer"),
                              _c(
                                "w-button-bar",
                                { class: { single: _vm.mainAddressSelected } },
                                [
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("tooltip.add-address"),
                                          expression:
                                            "$ct('tooltip.add-address')",
                                        },
                                      ],
                                      staticClass: "single",
                                      on: { click: _vm.addContact },
                                    },
                                    [_c("w-fa", { attrs: { icon: "plus" } })],
                                    1
                                  ),
                                  _c(
                                    "w-dropdown",
                                    {
                                      attrs: {
                                        items: _vm.buttonBarItems,
                                        right: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.trigger($event)
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "bars" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("w-row"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "transition",
                    { attrs: { name: "fast-fade", mode: "out-in" } },
                    [
                      _vm.activeAddress
                        ? _c("app-address", {
                            key: _vm.contact.Addresses.indexOf(
                              _vm.activeAddress
                            ),
                            attrs: {
                              "group-id": _vm.contact.GroupID,
                              "contact-address": _vm.activeAddress,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }